/**
 * RequestManagement object represents request management-related API endpoints and their methods.
 */
const RequestManagement = {
  /**
   * Endpoint for retrieving all users.
   * @memberof RequestManagement
   * @type {object}
   * @property {string} url - The URL for retrieving all users.
   * @property {string} method - The HTTP method for retrieving all users (GET).
   */
  getRequestData: {
    url: "/user-access-request/instructor",
    method: "GET",
  },

  /**
   * Endpoint for sending a request.
   * @memberof RequestManagement
   * @type {object}
   * @property {string} url - The URL for sending a request.
   * @property {string} method - The HTTP method for sending a request (POST).
   */
  sendRequest: {
    url: "/user-access-request/send",
    method: "POST",
  },
};

// Export the RequestManagement object for use in other modules
export default RequestManagement;
